import { render, staticRenderFns } from "./web-set-phone.vue?vue&type=template&id=33e80037&scoped=true&"
import script from "./web-set-phone.vue?vue&type=script&lang=js&"
export * from "./web-set-phone.vue?vue&type=script&lang=js&"
import style0 from "./web-set-phone.vue?vue&type=style&index=0&id=33e80037&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e80037",
  null
  
)

export default component.exports